import { useContext } from 'react';
import Image from '@next/image';

import SendIcon from 'assets/icons/send.svg';
import { FilesContext } from '@providers/FilesProvider';
import { ConfigContext } from '@providers/ConfigProvider';
import Typography from '@components/atoms/Typography';
import Button from '@components/atoms/Button';
import PhoneNumber from '@components/atoms/PhoneNumber';
import { FormattedMessage } from 'utils/intl';
import toLowerCase from 'utils/toLowerCase';

import classes from './EducationContactUs.module.scss';
import messages from './EducationContactUs.messages';

const EducationContactUs = () => {
  const { contact } = useContext(ConfigContext);
  const { getPageImageConfigs } = useContext(FilesContext);
  const [contactImage] = getPageImageConfigs(['contact-us']);

  return (
    <div className={classes.wrapper}>
      {contactImage && (
        <div className={classes.imageWrapper}>
          <Image alt="background" resolveConfig={contactImage} />
        </div>
      )}
      <div className={classes.texts}>
        <Typography variant="h1" renderAs="div">
          <FormattedMessage {...messages.header} />
        </Typography>
        <Typography variant="body1" renderAs="div">
          <FormattedMessage {...messages.description} />
        </Typography>
      </div>
      <div className={classes.actions}>
        <Button
          color="secondary"
          size="lg"
          icon={<SendIcon />}
          href={`mailto:edukacja@${toLowerCase(contact.appName)}`}
          customIconSize
        >
          <FormattedMessage {...messages.button} />
        </Button>
        <Typography variant="body1" className={classes.phoneWrapper}>
          <FormattedMessage
            {...messages.phone}
            values={{
              phone: (
                <PhoneNumber
                  tel={contact.landlinePhone}
                  phoneClassName={classes.phone}
                  variant="landline"
                  typographyVariant="body1"
                  weight="400"
                  withoutIcon
                />
              ),
            }}
          />
        </Typography>
      </div>
    </div>
  );
};

export default EducationContactUs;
